<template>
    <oss-dialog
        v-model="dialog"
        title="Importez votre relevé bancaire"
        :previous-display="wizardStep !== 0"
        :actions="actions"
        prefixDataCy="ImportBankMain-valid"
        min-width="70vw"
    >
        <v-window v-model="wizardStep">
            <v-window-item :value="0">
                <v-list>
                    <v-list-item
                        v-if="currentUser.profile.configuration.bankTransaction.import"
                        ripple
                        class="oss-list-item-xl mb-2 py-3"
                        @click="wizardStep = 1"
                        data-cy="importBankMain-csv"
                    >
                        <v-list-item-title>
                            Importer un fichier Excel ou CSV (recommandé)
                        </v-list-item-title>
                        <v-list-item-subtitle class="text-wrap">
                            Importez les relevés bancaires provenant d'un fichier fourni par le site
                            internet de votre banque au format Excel, .csv ou .tsv
                        </v-list-item-subtitle>
                        <template #append>
                            <v-icon size="x-small" color="light_grey">$fa-chevron-right</v-icon>
                        </template>
                    </v-list-item>
                    <v-list-item
                        v-if="currentUser.profile.configuration.bankTransaction.import"
                        ripple
                        class="oss-list-item-xl mb-2 py-3"
                        @click="wizardStep = 4"
                        data-cy="importBankMain-ofx"
                    >
                        <v-list-item-title>
                            Importer un fichier OFX (Open Financial Exchange)
                        </v-list-item-title>
                        <v-list-item-subtitle class="text-wrap">
                            Importez les relevés bancaires provenant d'un fichier fourni par le site
                            internet de votre banque au format OFX
                        </v-list-item-subtitle>
                        <template #append>
                            <v-icon size="x-small" color="light_grey">$fa-chevron-right</v-icon>
                        </template>
                    </v-list-item>
                    <v-list-item
                        v-if="currentUser.profile.configuration.bankTransaction.import"
                        ripple
                        class="oss-list-item-xl mb-2 py-3"
                        @click="
                            wizardStep = 3;
                            actions.action.previous = () => back();
                        "
                        data-cy="importBankMain-pdf"
                    >
                        <v-list-item-title>
                            Importer un fichier PDF (non recommandé)
                        </v-list-item-title>
                        <v-list-item-subtitle class="text-wrap">
                            Communiquez à votre cabinet comptable vos relevés bancaires au format
                            pdf. Cette méthode est à éviter si vous pouvez communiquer les
                            mouvements bancaires au format csv.
                        </v-list-item-subtitle>
                        <template #append>
                            <v-icon size="x-small" color="light_grey">$fa-chevron-right </v-icon>
                        </template>
                    </v-list-item>
                </v-list>
            </v-window-item>
            <v-window-item :value="1" class="pt-3" data-cy="ImportBankMain-import">
                <BankTransactionImport
                    v-if="
                        currentUser.profile.configuration.bankTransaction.import && wizardStep === 1
                    "
                    :scanBank="false"
                    :title="'Sélectionnez l\'export bancaire à importer (.csv, .xlsx, .tsv .txt)'"
                    :actions="actions"
                    :documentType="'BANK_STATEMENT'"
                    :selectedAccountId="selectedAccountId"
                    @documentImported="imported()"
                    @back="back()"
                />
            </v-window-item>
            <v-window-item :value="2">
                <BankTransactionImport
                    v-if="
                        currentUser.profile.configuration.bankTransaction.import && wizardStep === 2
                    "
                    :scanBank="true"
                    :title="'Sélectionnez l\'export ScanBank à importer'"
                    :actions="actions"
                    :documentType="'BANK_STATEMENT'"
                    :selectedAccountId="selectedAccountId"
                    @documentImported="imported()"
                    @back="back()"
                />
            </v-window-item>
            <v-window-item :value="3">
                <UploadDocuments
                    v-if="
                        currentUser.profile.configuration.bankTransaction.import && wizardStep === 3
                    "
                    :companyId="companyId"
                    :documentType="'BANK_STATEMENT'"
                    :multiple="true"
                    :freeTag="false"
                    :inExtensions="['pdf']"
                    :actions="actions"
                    @files-uploaded="imported"
                >
                </UploadDocuments>
            </v-window-item>
            <v-window-item :value="4">
                <BankTransactionImport
                    v-if="
                        currentUser.profile.configuration.bankTransaction.import && wizardStep === 4
                    "
                    :scanBank="false"
                    :ofx="true"
                    :title="'Sélectionnez l\'export OFX à importer'"
                    :actions="actions"
                    :documentType="'BANK_STATEMENT'"
                    :selectedAccountId="selectedAccountId"
                    @documentImported="imported()"
                    @back="back()"
                />
            </v-window-item>
        </v-window>
    </oss-dialog>
</template>

<script lang="ts">
import { User } from "../../../store/store";

import BankTransactionImport from "@/views/import/BankTransactionImport.vue";
import UploadDocuments from "../../document/UploadDocuments.vue";
import { DialogAction } from "../../../services/dialogAction";
import { Component, Vue, toNative, Watch, Model, Prop } from "vue-facing-decorator";

@Component({
    components: {
        BankTransactionImport,
        UploadDocuments,
    },
    emits: ["close", "bankTransactionImported", "excelTransactionImported"],
})
export class ImportBankMain extends Vue {
    @Model() value: boolean;
    @Prop({ default: "" }) readonly selectedAccountId: string;

    wizardStep = 0;

    actions = {
        action: new DialogAction(),
    };

    get currentUser(): User {
        return this.$store.state.user;
    }

    get companyId() {
        return this.$store.state.selected_company.id;
    }

    get dialog() {
        return this.value;
    }

    set dialog(data: boolean) {
        this.value = data;
    }

    beforeMount() {
        this.actions.action.display = false;
    }

    close() {
        debugger;
        this.$emit("close");
    }

    imported() {
        this.$emit("bankTransactionImported");
        this.close();
    }

    importedExcel() {
        this.$emit("excelTransactionImported");
        this.close();
    }

    back() {
        this.wizardStep = 0;
    }

    @Watch("wizardStep")
    updateAction() {
        if (this.wizardStep !== 3) this.actions.action.display = false;
        else this.actions.action.display = true;
    }
}

export default toNative(ImportBankMain);
</script>
